import React from "react";
import "./LoginPage.scss";
import {
  ILoginProps,
  ILoginState,
  IMFASessionResponseNormalized,
} from "../../../interfaces/Index";
import LoginPageLayout from "../../layouts/LoginPageLayout";
import ButtonComponent from "../../common/Button/ButtonComponent";
// import bazaarLogo from "../../../assets/bazaar-logo.svg";
import bazaarLogo from "./bazaar-logo.svg";
import ROUTES from "../../../config/RouteNames";
import TextField from "../../common/TextField/TextField";
import LoaderComponent from "../../common/Loader/Loader";
import {
  normalizeValidateMfaPayload,
  normalizedMfaFallbackPayload,
} from "../../../normalizer/AuthNormalizer";
import {
  JWT_TOKEN,
  JWT_TOKEN_EXPIRY,
  MFA_SESSION,
  MFA_SESSION_EXPIRY,
  CORRECT_PASSWORD,
  CORRECT_OTP,
  OTP_MESSAGE,
  WHATSAPP_OTP_MESSAGE,
  UNIDENTIFIED_ERROR,
  UNAUTHORIZED_ERROR,
} from "../../../config/constants";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { fetchShowPhoneLoginToggle } from "utils/ShowPhoneLoginToggle";
toast.configure();

export default class LoginPage extends React.Component<
  ILoginProps,
  ILoginState
> {
  constructor(props: ILoginProps) {
    super(props);

    this.state = {
      email: "",
      PASSWORD: "",
      OTP: "",
      currentStep: 0,
      whatsappBtn: 0,
      showPhoneLogin: false,
    };
  }

  async componentDidMount() {
    const authCode = new URLSearchParams(this.props.location?.search).get(
      "code"
    );

    await fetchShowPhoneLoginToggle(this.setShowPhoneLogin);

    if (!authCode) {
      return;
    }
    this.fetchTokens(authCode!);
  }

  setShowPhoneLogin = (value: boolean) => {
    this.setState({ showPhoneLogin: value });
  };

  public static getDerivedStateFromProps(props: ILoginProps) {
    const { history, userAuth } = props;
    if (userAuth && userAuth.token) {
      history.push(ROUTES.DASHBOARD_ROOT);
    }
    return null;
  }

  componentDidUpdate(prevProps: ILoginProps) {
    const { isError, error, isValidateMFASuccess } = this.props;
    if (isError && isError !== prevProps.isError) {
      if (typeof error === "object" && (error as any)?.data) {
        const message = UNAUTHORIZED_ERROR;
        this.handleToast(isError, message);
      } else if (
        (error! as any).errors[0].includes(
          "Unable to authenticate user against provided factor input"
        )
      ) {
        if (this.state.currentStep == 0 && isError) {
          const message = CORRECT_PASSWORD;
          this.handleToast(isError, message);
        } else if (this.state.currentStep == 1 && isError) {
          const message = CORRECT_OTP;
          this.handleToast(isError, message);
        }
      } else {
        if ((error! as any).errors == JWT_TOKEN) {
          const message = JWT_TOKEN_EXPIRY;
          this.handleToast(isError, message);
        } else if ((error! as any).errors == MFA_SESSION) {
          const message = MFA_SESSION_EXPIRY;
          this.handleToast(isError, message);
        } else {
          alert((error! as any).errors);
        }
      }
    } else if (
      isValidateMFASuccess &&
      prevProps.isValidateMFASuccess !== isValidateMFASuccess
    ) {
      this.setState({
        currentStep: ((this.state.currentStep as number) += 1),
      });
      if (this.state.currentStep == 1 && !this.state.isError) {
        const message = OTP_MESSAGE;
        this.handleToast(isError, message);
      }
    }
  }

  handleChange = (e: any) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  handleEnterKeyPress = (e: any) => {
    if (e.key === "Enter") {
      this.props.mfa ? this.validateMfaSession() : this.getMfaSession();
    }
  };

  validateMfaSession = () => {
    const { validateMfaSession, mfa } = this.props;
    const { currentStep } = this.state;

    const factorData: any =
      this.state[
        (mfa as IMFASessionResponseNormalized).factors[currentStep as number]
          .name
      ];
    const payload = normalizeValidateMfaPayload(
      factorData,
      (mfa as IMFASessionResponseNormalized).token
    );
    validateMfaSession(payload);
  };

  generateCodeChallenge = async (codeVerifier: string) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const digest = await window.crypto.subtle.digest("SHA-256", data);
    const base64String = btoa(
      String.fromCharCode.apply(null, new Uint8Array(digest) as any)
    );
    return base64String
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  };

  fetchTokens = (authorizationCode: string) => {
    const { validateKeycloakSessionAction } = this.props;
    const clientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID!;
    const redirectUri = `${window.location.origin}/login`;

    const googleIdentityPayload = {
      authorizationCode: authorizationCode,
      redirectUri: redirectUri,
      clientId: clientId,
      bazaarClientName: "Commando",
    };
    validateKeycloakSessionAction(googleIdentityPayload);
  };

  generateRandomString = (length: number) => {
    var array = new Uint8Array(length);
    window.crypto.getRandomValues(array);
    return Array.from(array, (dec) => ("0" + dec.toString(16)).substr(-2)).join(
      ""
    );
  };

  redirectKeycloakLogin = async () => {
    const oidcProviderAuthUrl = process.env.REACT_APP_OIDC_PROVIDER_AUTH_URL;
    const clientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;
    const redirectUri = `${window.location.origin}/login`;
    const responseType = "code";

    const loginUrl = `${oidcProviderAuthUrl}?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=${responseType}&prompt=consent&access_type=offline&scope=openid profile email`;
    window.location.replace(loginUrl);
  };

  initiateWhatsappFallback = () => {
    const { mfaFallbackSession, mfa, isError, error } = this.props;
    const payload = normalizedMfaFallbackPayload(
      "WHATSAPP_OTP",
      (mfa as IMFASessionResponseNormalized).token
    );
    mfaFallbackSession(payload);
    if ((error! as any).errors === JWT_TOKEN) {
      const message = JWT_TOKEN_EXPIRY;
      this.handleToast(isError, message);
    } else if (!isError) {
      this.handleToast(false, WHATSAPP_OTP_MESSAGE);
    }
  };

  getMfaSession = () => {
    const { getMfaSession } = this.props;
    getMfaSession({
      username: this.state.email as string,
    });
  };

  renderEmailUserNameField = () => {
    return (
      <TextField
        id="email"
        type="tel"
        label="Phone number"
        placeholder="Enter phone number"
        value={this.state.email}
        handleChange={this.handleChange}
        onKeyPress={this.handleEnterKeyPress}
        maxLength={11}
      />
    );
  };

  renderWhatsappBtn = () => {
    const { whatsappBtn } = this.state;

    setTimeout(() => {
      this.setState({ whatsappBtn: 1 });
    }, 60000);

    return whatsappBtn ? (
      <div className="whatsapp-text" onClick={this.initiateWhatsappFallback}>
        Send OTP on Whatsapp
      </div>
    ) : null;
  };

  renderPasswordField = () => {
    return (
      <TextField
        id="PASSWORD"
        label="password"
        placeholder="Enter password"
        type="password"
        value={this.state.PASSWORD}
        handleChange={this.handleChange}
        onKeyPress={this.handleEnterKeyPress}
      />
    );
  };

  renderOTPField = () => {
    return (
      <TextField
        id="OTP"
        label="OTP"
        placeholder="Enter OTP"
        // type="password"
        maxLength={6}
        value={this.state.OTP}
        handleChange={this.handleChange}
        onKeyPress={this.handleEnterKeyPress}
      />
    );
  };

  renderButtonComponent = () => {
    const btnText = this.props.mfa
      ? this.props.mfa.factors &&
        this.props.mfa.factors.length > 0 &&
        this.state.currentStep === this.props.mfa.factors.length - 1
        ? "Login"
        : "Continue"
      : "Continue";
    return (
      <ButtonComponent
        buttonText={btnText}
        buttonStyles={{
          width: "100%",
          marginTop: "12px",
        }}
        onClickHandler={
          this.props.mfa ? this.validateMfaSession : this.getMfaSession
        }
      />
    );
  };

  handleToast = (isError: any, message: any) => {
    if (isError) {
      toast.error(message, { autoClose: 4000, hideProgressBar: true });
    } else {
      toast.success(message, { autoClose: 4000, hideProgressBar: true });
    }
  };

  loginWithKeycloakButton = () => {
    return (
      <ButtonComponent
        buttonText={"Login with Google"}
        buttonStyles={{
          width: "100%",
          marginTop: "12px",
        }}
        buttonClass="btn-danger-outline"
        onClickHandler={this.redirectKeycloakLogin}
      />
    );
  };
  public render() {
    const steps: any = {
      PASSWORD: this.renderPasswordField(),
      OTP: this.renderOTPField(),
    };
    const { currentStep } = this.state;
    const { mfa } = this.props;
    return (
      <LoginPageLayout>
        {this.props.isLoading && <LoaderComponent />}
        <img src={bazaarLogo} alt="Bazaar Logo" />
        <div className="login-form-container">
          {this.state.showPhoneLogin && (
            <>
              {mfa && mfa.factors && mfa.factors.length > 0
                ? steps[mfa.factors[currentStep as number].name]
                : this.renderEmailUserNameField()}
              {this.renderButtonComponent()}
            </>
          )}
          {this.loginWithKeycloakButton()}

          {mfa &&
          mfa.factors &&
          mfa.factors.length > 0 &&
          mfa.factors[currentStep as number].fallbacks.find(
            (e) => e.name === "WHATSAPP_OTP"
          )
            ? this.renderWhatsappBtn()
            : false}
        </div>
      </LoginPageLayout>
    );
  }
}
